export default "/images/13715bbf2e1a475c0e33b7b3594b7226.png";